module.exports = __webpack_public_path__ + "img/11.81392e8d.png";